import {
  GET_GUESTS_SUCCESS,
  GET_GUESTS_FAIL,
} from "./actionTypes";
const INIT_STATE = {
  error: {},
  guests: [],
};

const projects = (state = INIT_STATE, action) => {
  switch (action.type) {


    case GET_GUESTS_SUCCESS:
      return {
        ...state,
        guests: action.payload,
      };

    case GET_GUESTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default projects;
